import type { WheelEvent } from "react";
import type { FieldError } from "react-hook-form";
import classNames from "classnames";
import cn from "classnames";
import { ErrorMessage } from "../ErrorMessage";
import { Input } from "../Input/Input";
import inputStyles from "../Input/Input.module.scss";
import style from "./FormField.module.scss";

type FormFieldProps = {
  name: string;
  labelTitle: string;
  type?: string;
  isPassword?: boolean;
  className?: string;
  placeholder?: string;
  required?: boolean;
  multiline?: boolean;
  value: string;
  onChange: (value: string) => void;
  onBlur?: () => void;
  onWheel?: (e: WheelEvent<HTMLInputElement>) => void;
  error?: FieldError;
  disabled?: boolean;
};

export const FormField = ({
  name,
  labelTitle,
  type = "text",
  className,
  placeholder,
  required = false,
  multiline = false,
  value = "",
  onChange,
  onBlur,
  onWheel,
  error,
  disabled = false,
}: FormFieldProps) => {
  return (
    <div className={classNames(style.formField, className)}>
      <div className={style.formFieldLabel}>
        <label className={style.formFieldLabelTitle} htmlFor={name}>
          {labelTitle}
          {required && "*"}
        </label>
      </div>
      <div className={style.formFieldInputWrapper}>
        {multiline ? (
          <textarea
            id={name}
            disabled={disabled}
            className={classNames(inputStyles.input, inputStyles.inputTextarea, {
              [inputStyles.inputError]: error,
              [inputStyles.inputDisabled]: disabled,
            })}
            placeholder={placeholder}
            value={value}
            onChange={(e) => onChange(e.target.value)}
            onBlur={onBlur}
          />
        ) : (
          <Input
            id={name}
            placeholder={placeholder}
            type={type}
            value={value}
            disabled={disabled}
            onChange={(e) => onChange(e.target.value)}
            onBlur={onBlur}
            onWheel={onWheel}
            error={!!error}
          />
        )}
      </div>
      <ErrorMessage error={error} />
    </div>
  );
};
